var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLaw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1735_773)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3493 20.1907C17.5979 20.1907 21.8527 16.0582 21.8527 10.9606C21.8527 5.86293 17.5979 1.73047 12.3493 1.73047C9.34106 1.73047 6.6593 3.08798 4.91797 5.20666C6.54243 3.4487 8.90003 2.34284 11.5236 2.34284C16.424 2.34284 20.3966 6.2012 20.3966 10.9607C20.3966 15.7203 16.424 19.5786 11.5236 19.5786C8.90139 19.5786 6.54488 18.4739 4.92049 16.7176C6.66189 18.8345 9.34252 20.1907 12.3493 20.1907Z",
    fill: "url(#paint0_linear_1735_773)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.383 21.118C5.60806 21.118 0.926573 16.5711 0.926573 10.9623C0.926573 5.35349 5.60806 0.806641 11.383 0.806641C13.9446 0.806641 16.2912 1.70133 18.1094 3.18654C16.4783 2.03524 14.471 1.3562 12.3005 1.3562C6.83765 1.3562 2.40917 5.65733 2.40917 10.963C2.40917 16.2688 6.83765 20.5699 12.3005 20.5699C14.4653 20.5699 16.4676 19.8944 18.0964 18.7487C16.28 20.2276 13.9385 21.118 11.383 21.118Z",
    fill: "#5F1314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2819 6.27468C10.3122 4.36744 8.44547 4.22613 7.45149 4.29681C7.2818 4.28641 6.96662 4.68885 6.99087 4.79089C9.2455 4.48517 10.7647 5.70172 11.2819 6.27468Z",
    fill: "#5F1314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2819 7.00421C10.3122 5.15819 7.56462 4.99494 6.31205 5.14406C6.02113 5.1787 5.93224 5.5679 5.89992 5.68563C8.63457 5.23354 10.6435 6.35277 11.2819 7.00421Z",
    fill: "#5F1314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80896 6.1801C4.51804 6.25515 4.45339 6.67457 4.44531 6.81584C8.71215 5.56789 10.4577 7.16904 11.2819 7.82833C9.65278 5.34185 6.36054 5.77981 4.80896 6.1801Z",
    fill: "#5F1314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4759 6.27468C12.4456 4.36744 14.3123 4.22613 15.3063 4.29681C15.476 4.28641 15.7912 4.68885 15.7669 4.79089C13.5123 4.48517 11.9931 5.70172 11.4759 6.27468Z",
    fill: "#5F1314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4759 7.00421C12.4456 5.15819 15.1932 4.99494 16.4458 5.14406C16.7367 5.1787 16.8256 5.5679 16.8579 5.68563C14.1232 5.23354 12.1143 6.35277 11.4759 7.00421Z",
    fill: "#5F1314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9488 6.1801C18.2398 6.25515 18.3044 6.67457 18.3125 6.81584C14.0457 5.56789 12.3001 7.16904 11.4759 7.82833C13.105 5.34185 16.3973 5.77981 17.9488 6.1801Z",
    fill: "#5F1314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4066 18.1609V8.45985C10.9023 8.49753 10.6793 8.29515 10.5096 7.94194C10.3406 7.59017 8.86102 5.96411 3.96385 7.21189C3.76993 7.32976 3.89114 7.54597 4.03658 7.51799C6.60638 7.02369 7.16398 7.04723 8.25493 7.14125C9.24505 7.22658 10.1469 7.89929 10.1944 8.1302C10.2186 8.24806 10.3883 8.45997 10.6065 8.62467V15.147C9.32649 15.2411 9.13577 16.3478 9.20042 16.8894H8.42463V18.1609H11.4066Z",
    fill: "url(#paint1_linear_1735_773)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8072 12.323H7.13558L5.44727 7.73167L3.8072 12.323ZM7.62027 12.323H7.78898C7.67911 13.459 6.69447 14.348 5.49605 14.348C4.29763 14.348 3.313 13.459 3.20312 12.323H3.34689L5.30181 7.04883H5.64122L7.62027 12.323Z",
    fill: "url(#paint2_linear_1735_773)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3864 18.1609V8.45985C11.8907 8.49753 12.1137 8.29515 12.2834 7.94194C12.4524 7.59017 13.932 5.96411 18.8291 7.21189C19.023 7.32976 18.9018 7.54597 18.7564 7.51799C16.1866 7.02369 15.629 7.04723 14.538 7.14125C13.5479 7.22658 12.6461 7.89929 12.5986 8.1302C12.5743 8.24806 12.4046 8.45997 12.1864 8.62467V15.147C13.4665 15.2411 13.6572 16.3478 13.5925 16.8894H14.3683V18.1609H11.3864Z",
    fill: "url(#paint3_linear_1735_773)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9895 12.323H15.6611L17.3494 7.73167L18.9895 12.323ZM15.1764 12.323H15.0076C15.1166 13.4599 16.1016 14.3498 17.3007 14.3498C18.4997 14.3498 19.4847 13.4599 19.5938 12.323H19.4498L17.4949 7.04883H17.1555L15.1764 12.323Z",
    fill: "url(#paint4_linear_1735_773)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1735_773",
    x1: 21.8527,
    y1: 10.9606,
    x2: 4.91797,
    y2: 10.9606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1735_773",
    x1: 11.4066,
    y1: 12.4545,
    x2: 3.86328,
    y2: 12.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1735_773",
    x1: 7.78898,
    y1: 10.6984,
    x2: 3.20312,
    y2: 10.6984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1735_773",
    x1: 11.3864,
    y1: 12.4545,
    x2: 18.9297,
    y2: 12.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1735_773",
    x1: 15.0076,
    y1: 10.6993,
    x2: 19.5938,
    y2: 10.6993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1673,
    height: 21.1673,
    fill: "white",
    transform: "translate(0.722656 0.474609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaw);
export default __webpack_public_path__ + "static/media/icon-law.05ea49e3e6095ac1f556ea93814d7a42.svg";
export { ForwardRef as ReactComponent };